import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareBehindSquare1"><Path d="M15.5 8.5V2.5H2.5V15.5H8.5M8.5 8.5H21.5V21.5H8.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
